var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-table-list"},[_c('Table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }